export type Changelog = ChangelogEntry[];

export type ChangelogEntry = {
  EndretDato: string;
  EndretAv: string;
  Endringer: Endringer[];
};

export type Endringer = {
  EndretFelt: Feltnavn;
  NyVerdi: string;
  EndringType: EndringType;
};

export enum Feltnavn {
  OppgaveStatus = 1,
  StatusBegrunnelse = 2,
  // GydligFraDato = 3,
  // GyldigTilDato = 4,
  Frist = 5,
  Beskrivelse = 6,
  // ElementReferanse = 7,
  Notat = 8,
}

export enum EndringType {
  None = 0,
  Added = 1,
  Deleted = 2,
  Modified = 3,
}
